export default __webpack_public_path__ + "./fonts/user.17b4c958.svg";